<template>
    <div v-if="visible" class="modal-overlay" @click="handleClose" :class="{ 'attachment-open': attachmentVisible }">
        <div class="modal-content" @click.stop>
            <div class="modal-header">
                <h2 class="modal-title">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </svg>
                    <span>创建帖子</span>
                </h2>
                <button class="close-btn" @click="handleClose">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                </button>
            </div>

            <div class="modal-body">
                <!-- 文本输入区域 -->
                <div class="text-input-container">
                    <textarea v-model="postData.text" class="post-textarea" placeholder="在这里写下您的帖子内容..."
                        maxlength="1500"></textarea>
                    <div class="char-count">
                        <div class="char-progress" :style="{ width: (postData.text.length / 1500) * 100 + '%' }"></div>
                        <span>{{ postData.text.length }}/1500</span>
                    </div>
                </div>

                <!-- 图片上传区域 -->
                <div class="upload-section">
                    <div class="upload-header">
                        <h3 class="upload-title">添加图片</h3>
                        <div class="upload-count">{{ postData.images.length }}/10</div>
                    </div>

                    <!-- 图片容器：包含上传区域和已选择的图片 -->
                    <div class="images-container">
                        <!-- 上传区域 -->
                        <div class="upload-area" @click="openAttachmentModal"
                            :class="{ disabled: postData.images.length >= 10 }">
                            <div class="upload-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                                </svg>
                            </div>
                            <div class="upload-text">{{ postData.images.length >= 10 ? '已达到上限' : '添加照片' }}</div>
                            <div class="upload-hint">支持 JPG、PNG 格式，最多10张</div>
                        </div>

                        <!-- 已选择的图片预览 -->
                        <div v-for="(image, index) in postData.images" :key="index" class="image-preview">
                            <img :src="getImageUrl(image)" :alt="`图片 ${index + 1}`" />
                            <div class="image-number">{{ index + 1 }}</div>
                            <button class="remove-image" @click="removeImage(index)" title="删除图片">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- 图片数量提示 -->
                    <div v-if="postData.images.length === 0" class="image-warning">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                        </svg>
                        <span>请至少添加一张图片</span>
                    </div>
                </div>

                <!-- 按钮区域 -->
                <div class="modal-actions">
                    <button class="btn btn-primary" @click="handleSubmit">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                        </svg>
                        <span>发送审核</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Attachment组件 -->
        <attachment ref="attachmentDom" :chatUserInfo="attachmentUserInfo" :photoOnly="true" :approvedOnly="true"
            :forceTalkytimesPath="true" @get-sonMediaMessage="handleAttachmentSelection"
            @visible-change="handleAttachmentVisibleChange" :currentMessageType="currentMessageType" />
    </div>
</template>

<script>
import attachment from '@/views/talkytimes/views/message/components/attachment.vue'
import { createNewsFeedPost } from '@/api/talkytimes/newsFeed'

export default {
    name: 'CreatePostModal',
    components: {
        attachment
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        // 从 localStorage 获取 activeUser
        const activeUserStr = localStorage.getItem('activeUser');
        let attachmentUserInfo = {
            userId: 'default',
            platformUserId: 'default',
            idInterlocutor: 'default',
            userDetail: {
                name: '用户',
                avatar_large: null
            }
        };
        
        if (activeUserStr) {
            const activeUser = JSON.parse(activeUserStr);
            attachmentUserInfo = {
                userId: activeUser.id || activeUser.userId || activeUser.platformUserId || 'default',
                platformUserId: activeUser.id || activeUser.platformUserId || 'default',
                idInterlocutor: activeUser.id || activeUser.platformUserId || activeUser.userId || 'default',
                userDetail: {
                    name: activeUser.name || '用户',
                    avatar_large: activeUser.personalAvatar_xl || activeUser.avatar_large || null
                }
            };
        }
        
        return {
            postData: {
                text: '',
                images: []
            },
            attachmentUserInfo,
            attachmentVisible: false,
            currentMessageType: 'newsFeed'
        }
    },
    methods: {
        // 更新 attachmentUserInfo，确保使用最新的 activeUser
        updateAttachmentUserInfo() {
            const activeUserStr = localStorage.getItem('activeUser');
            if (activeUserStr) {
                const activeUser = JSON.parse(activeUserStr);
                this.attachmentUserInfo = {
                    userId: activeUser.id || activeUser.userId || activeUser.platformUserId || 'default',
                    platformUserId: activeUser.id || activeUser.platformUserId || 'default',
                    idInterlocutor: activeUser.id || activeUser.platformUserId || activeUser.userId || 'default',
                    userDetail: {
                        name: activeUser.name || '用户',
                        avatar_large: activeUser.personalAvatar_xl || activeUser.avatar_large || null
                    }
                };
            }
        },
        handleClose() {
            this.$emit('close');
            this.resetForm();
        },
        openAttachmentModal() {
            if (this.postData.images.length >= 10) {
                this.$emit('error', '最多只能上传10张图片');
                return;
            }
            // 在打开媒体库前更新用户信息
            this.updateAttachmentUserInfo();
            // 打开attachment组件
            console.log('Opening attachment modal...');
            this.$refs.attachmentDom.init();
        },
        handleAttachmentSelection(data) {
            // 处理从attachment组件选择的图片
            console.log('handleAttachmentSelection', data);
            const selectedImages = data.dataMsgList || [];
            const remainingSlots = 10 - this.postData.images.length;

            if (selectedImages.length > remainingSlots) {
                this.$emit('error', `最多只能再添加${remainingSlots}张图片`);
                selectedImages.splice(remainingSlots);
            }

            // 将选中的图片添加到postData.images中
            this.postData.images = [...this.postData.images, ...selectedImages];
        },
        handleAttachmentVisibleChange(visible) {
            // 当attachment组件打开时，降低CreatePostModal的z-index
            this.attachmentVisible = visible;
            const modalOverlay = document.querySelector('.modal-overlay');
            if (modalOverlay) {
                if (visible) {
                    modalOverlay.style.zIndex = '999';
                } else {
                    modalOverlay.style.zIndex = '1000';
                }
            }
        },
        getImageUrl(file) {
            // 如果是File对象，使用URL.createObjectURL
            if (file instanceof File) {
                return URL.createObjectURL(file);
            }
            // 如果是attachment组件返回的对象，使用其url属性
            return file.url || file.originalUrl || file;
        },
        removeImage(index) {
            this.postData.images.splice(index, 1);
        },
        handlePreview() {
            if (this.postData.images.length === 0) {
                this.$emit('error', '请至少添加一张图片');
                return;
            }
            this.$emit('preview', this.postData);
        },
        handleSubmit() {
            let imagesList = [];
            if (this.postData.images.length === 0) {
                this.$emit('error', '请至少添加一张图片');
                return;
            } else {
                for (let i = 0; i < this.postData.images.length; i++) {
                    imagesList.push(this.postData.images[i].idPhoto)
                }
            }
            let params = {
                content: {
                    text: this.postData.text,
                    images: imagesList
                },
                type: 'post'
            }
            createNewsFeedPost(params).then(res => {
                console.log('createNewsFeedPost', res);
                this.resetForm();
                // 通知父组件创建成功，需要更新列表
                this.$emit('success', res);
                // 关闭弹窗
                this.handleClose();
            }).catch(error => {
                console.error('创建帖子失败:', error);
                this.$emit('error', '创建帖子失败，请重试');
            })
        },
        resetForm() {
            this.postData = {
                text: '',
                images: []
            };
        }
    }
}
</script>

<style scoped lang="scss">
/* 弹窗样式 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;
    pointer-events: auto;
}

.modal-overlay.attachment-open {
    background: transparent;
    backdrop-filter: none;
    pointer-events: none;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.modal-content {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 20px;
    width: 90%;
    max-width: 700px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px 32px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.8);
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 20px 20px 0 0;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
}

.modal-title svg {
    width: 28px;
    height: 28px;
    color: #8b5cf6;
}

.close-btn {
    background: rgba(243, 244, 246, 0.8);
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #6b7280;
    padding: 8px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.close-btn:hover {
    color: #1f2937;
    background: rgba(239, 68, 68, 0.1);
    transform: rotate(90deg);
}

.modal-body {
    padding: 32px;
}

.text-input-container {
    position: relative;
    margin-bottom: 28px;
}

.post-textarea {
    width: 100%;
    min-height: 180px;
    padding: 20px;
    border: 2px solid rgba(209, 213, 219, 0.8);
    border-radius: 12px;
    font-family: inherit;
    font-size: 15px;
    resize: vertical;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.8);
    transition: all 0.3s ease;
    line-height: 1.6;
}

.post-textarea:focus {
    outline: none;
    border-color: #8b5cf6;
    box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.1);
    background: white;
}

.post-textarea::placeholder {
    color: #9ca3af;
    font-weight: 400;
}

.char-count {
    position: absolute;
    bottom: 12px;
    right: 12px;
    color: #6b7280;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.9);
    padding: 4px 8px;
    border-radius: 6px;
}

.char-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    border-radius: 2px;
    transition: width 0.3s ease-in-out;
}

.upload-section {
    margin-bottom: 28px;
}

.upload-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.8);
}

.upload-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.upload-count {
    font-size: 16px;
    font-weight: 500;
    color: #8b5cf6;
    background: rgba(139, 92, 246, 0.1);
    padding: 4px 10px;
    border-radius: 8px;
}

.upload-area {
    width: 120px;
    height: 120px;
    border: 3px dashed rgba(209, 213, 219, 0.8);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: rgba(249, 250, 251, 0.8);
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
}

.upload-area::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(139, 92, 246, 0.1), transparent);
    transition: left 0.5s;
}

.upload-area:hover::before {
    left: 100%;
}

.upload-area:hover {
    border-color: #8b5cf6;
    background: rgba(240, 247, 255, 0.8);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(139, 92, 246, 0.15);
}

.upload-area.dragover {
    border-color: #8b5cf6;
    background: rgba(224, 231, 255, 0.8);
    box-shadow: 0 0 20px rgba(139, 92, 246, 0.3);
    transform: scale(1.02);
}

.upload-area.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    border-color: #e5e7eb;
    background: #f9fafb;
    transform: none;
    box-shadow: none;
}

.upload-icon {
    margin-bottom: 8px;
    color: #8b5cf6;
    transition: all 0.3s ease;
}

.upload-area:hover .upload-icon {
    transform: scale(1.1);
}

.upload-text {
    color: #8b5cf6;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 4px;
}

.upload-hint {
    font-size: 10px;
    color: #9ca3af;
    text-align: center;
    line-height: 1.2;
}

/* 图片容器样式 */
.images-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;
}

/* 已选择图片预览样式 */
.selected-images {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 20px;
}

.image-preview {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid rgba(229, 231, 235, 0.8);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.image-preview:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-number {
    position: absolute;
    top: 6px;
    left: 6px;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 8px;
    backdrop-filter: blur(5px);
}

.remove-image {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
    background: rgba(239, 68, 68, 0.9);
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.remove-image:hover {
    background: #ef4444;
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.image-warning {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #f59e0b;
    font-size: 14px;
    font-weight: 500;
    margin-top: 16px;
    padding: 10px 15px;
    background: rgba(251, 191, 36, 0.1);
    border: 1px solid #fcd34d;
    border-radius: 10px;
    backdrop-filter: blur(5px);
}

.modal-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 28px;
    padding-top: 20px;
    border-top: 1px solid rgba(229, 231, 235, 0.8);
}

.btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
}

.btn:hover::before {
    left: 100%;
}

.btn-primary {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.btn-primary:hover {
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(139, 92, 246, 0.4);
}

.btn-secondary {
    background: rgba(255, 255, 255, 0.9);
    color: #8b5cf6;
    border: 2px solid rgba(139, 92, 246, 0.3);
    backdrop-filter: blur(10px);
}

.btn-secondary:hover {
    background: rgba(139, 92, 246, 0.1);
    border-color: #8b5cf6;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(139, 92, 246, 0.2);
}

.requirements-link {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #8b5cf6;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 12px;
    border-radius: 8px;
    transition: all 0.3s ease;
    margin-left: auto;
}

.requirements-link:hover {
    color: #7c3aed;
    background: rgba(139, 92, 246, 0.1);
    transform: translateY(-1px);
}

/* 滚动条样式 */
.modal-content::-webkit-scrollbar {
    width: 8px;
}

.modal-content::-webkit-scrollbar-track {
    background: rgba(241, 245, 249, 0.8);
    border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
    background: rgba(139, 92, 246, 0.3);
    border-radius: 4px;
    transition: background 0.3s ease;
}

.modal-content::-webkit-scrollbar-thumb:hover {
    background: rgba(139, 92, 246, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
    .modal-content {
        width: 95%;
        margin: 20px;
    }

    .modal-body {
        padding: 24px;
    }

    .modal-header {
        padding: 20px 24px;
    }

    .modal-title {
        font-size: 20px;
    }

    .modal-actions {
        flex-direction: column;
        gap: 12px;
    }

    .requirements-link {
        margin-left: 0;
        justify-content: center;
    }
}

::v-deep .el-dialog {
    border-radius: 30px;
    z-index: 10000 !important;
}

::v-deep .el-dialog__header {
    padding: 0;
    z-index: 1 !important;
}

::v-deep .el-dialog__body {
    padding: 24px;
}

::v-deep .el-dialog {
    margin-top: 5vh !important;

    .el-dialog__body {
        height: calc(90vh - 10px);
        box-sizing: border-box;
    }
}

/* 确保attachment组件的dialog在最顶层 */
::v-deep .attachment .el-dialog {
    z-index: 10000 !important;
}

::v-deep .attachment .el-dialog__wrapper {
    z-index: 10000 !important;
}
</style>